<template>
  <div v-show="usableTimeCards.length > 0" class="timeCardsWrap">
    <div class="timeCardTitle">
      {{ TLang("次卡", "orderConfirm") }}
    </div>
    <div
      v-for="good of usableTimeCards"
      :key="good.goodsId + '-' + good.categoryId"
      class="timeCardContent"
    >
      <div class="timeCardProduct">
        <div class="timeCardProductImg">
          <img :src="good.logo" />
        </div>
        <div class="timeCardProductInfo">
          <div class="timeCardPropductName">
            {{ good.name }}
          </div>
          <div class="timeCardPropductNum">
            {{ `${getPriceDeal(good.price)}X${good.num}` }}
          </div>
        </div>
        <div v-show="good.isDisplayPrice !== 0" class="timeCardPproductPrice">
          <img
            :src="union_icon || require('@/assets/images/fudou.png')"
            alt
            class="fudou-15"
          />
          <em>{{ getPriceDeal(good.price * good.num) }}</em>
        </div>
      </div>
      <div v-if="good.timeCards && good.timeCards.length > 0" class="timeCards">
        <div
          v-for="card of good.timeCards"
          :key="card.cardNo + '-' + good.goodsId + '-' + good.categoryId"
          :class="['timeCard', card.checked === 'Y' ? 'selected' : '']"
          @click="bigCardClick(card, good)"
        >
          <div v-if="card.checked !== 'Y' && !card.showBalance">
            <div class="unUsedCardInfo">
              <div class="cardName">
                {{ card.kindName }}
              </div>
              <div class="un-cardTxt">
                {{ TLang("可用次数", "orderConfirm") }}
              </div>

              <div class="un-cardBalance">
                {{ card.showBalance
                }}<em> {{ TLang("次", "orderConfirm") }}</em>
              </div>
              <div class="cardNo">
                {{ TLang("卡号", "card") }}:{{ card.cardNo }}
              </div>
              <div class="cardRange">
                <span class="cardTime" v-if="!cardExpireShowType || cardExpireShowType === 1"
                  >{{ TLang("有效期至", "card") }}<span
                    :class="[card.fastExpiration === 'Y' ? 'red-font' : '']"
                    >{{ formatTime(card.expireDate) }}</span
                  ></span
                >
                <span class="cardTime" v-else-if="cardExpireShowType === 2"
                  >{{ TLang("有效期至", "card") }}
                  <span>{{ TLang("长期有效", "card")  }}</span
                  ></span
                >
                <span class="cardTips">
                  <el-popover
                    popper-class="useScope"
                    placement="bottom-start"
                    title=""
                    max-width="300"
                    trigger="hover"
                    :content="card.kindDesc"
                  >
                    <el-button slot="reference"
                      ><img
                        :src="require('@/assets/images/order/tips.png')"
                      /><em class="tipTxt">&nbsp;&nbsp;</em></el-button
                    >
                  </el-popover>
                </span>
              </div>
            </div>
          </div>
          <div v-else class="timeCardInfo">
            <div class="cardName">
              {{ unionF ? card.kindForeignName : card.kindName }}
            </div>
            <div class="cardTxt">
              {{ TLang("可用次数", "orderConfirm") }}
            </div>
            <div class="cardBalance">
              {{ card.showBalance }}<em> {{ TLang("次", "orderConfirm") }}</em>
            </div>
            <div class="cardNo">
              {{ TLang("卡号", "card") }}:{{ card.cardNo }}
            </div>
            <div class="cardRange">
              <span class="cardTime"  v-if="!cardExpireShowType || cardExpireShowType === 1">
                {{ TLang("有效期至", "card") }}<span
                  :class="[card.fastExpiration === 'Y' ? 'red-font' : '']"
                  >{{ formatTime(card.expireDate) }}</span
                ></span
              >
              <span class="cardTime"  v-else-if="cardExpireShowType === 2">
                {{ TLang("有效期至", "card") }}
                <span>{{  TLang("长期有效", "card") }}</span
                ></span
              >
              <span class="cardTips">
                <el-popover
                  popper-class="useScope"
                  placement="bottom-start"
                  title=""
                  max-width="300"
                  trigger="hover"
                  :content="card.kindDesc"
                >
                  <el-button slot="reference"
                    ><img :src="require('@/assets/images/order/tips.png')" /><em
                      class="tipTxt"
                      >&nbsp; {{ TLang("使用范围", "orderConfirm") }}</em
                    ></el-button
                  >
                </el-popover>
              </span>
            </div>
            <img
              class="selectedImg"
              :src="require('@/assets/images/selected.png')"
            />
          </div>
        </div>
      </div>
      <div class="one-time">
        <div
          class="one"
          v-for="card of good.timeCards"
          :key="card.cardNo + '-' + good.goodsId + '-' + good.categoryId"
        >
          <div
            v-if="card.checked !== 'Y' && !card.showBalance"
            class="cardNumTwo"
          >
            <span class="cardReduce unuseable">-</span>
            <input
              v-model="card.checkedValue"
              class="cardInput unuseable"
              type="number"
              placeholder="0"
            />
            <span class="cardReduce unuseable">+</span>
          </div>
          <div v-else class="cardNumTwo">
            <span
              :class="{
                cardReduce: true,
                gray: card.checked === 'N' || !card.checkedValue,
              }"
              @click="
                (e) => {
                  card.checked === 'N' || !card.checkedValue
                    ? null
                    : clickTimeCard(e, card, '-', good);
                }
              "
              >-</span
            >
            <input
              v-model="card.checkedValue"
              class="cardInput"
              type="number"
              placeholder="0"
              @keyup="(e) => clickTimeCard(e, card, 'input', good)"
            />
            <span
              :class="{
                cardAdd: true,
                gray: card.checkedValue >= Math.min(good.num, card.balance),
              }"
              @click="
                (e) => {
                  card.checkedValue >= Math.min(good.num, card.balance)
                    ? null
                    : clickTimeCard(e, card, '+', good);
                }
              "
              >+</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from "@components/simpleToast";
import { payTotastNames } from "@utils/config";
import { getQueryString, unionFlag, gioClickHandle } from '@utils/index';
import unUsedCard from "../unUsedCards";

export default {
  name: "TimeCard",
  components: {
    unUsedCard,
  },
  props: {
    // 卡数据
    interestsInfo: Object,
    sendGio: Function,
  },
  data() {
    return {
      cards: JSON.parse(JSON.stringify(this.interestsInfo)),
      now: new Date().getTime(),
      unionF: unionFlag() || sessionStorage.getItem('dffl_union')
    };
  },
  computed: {
    // 卡信息
    cardInfo() {
      if (this.cards.cardInfo) {
        return this.cards.cardInfo;
      }
      return {};
    },
    cardExpireShowType() {
      if (this.cards && this.cards.cardExpireShowType) {
        return this.cards.cardExpireShowType;
      }
      return null;
    },
    // 可用次卡
    usableTimeCards() {
      if (
        this.cardInfo &&
        this.cardInfo.usableCardInfo &&
        this.cardInfo.usableCardInfo.goodsCardList &&
        this.cardInfo.usableCardInfo.goodsCardList.length > 0
      ) {
        return this.cardInfo.usableCardInfo.goodsCardList;
      }
      return [];
    },
    // // 总抵扣额度等于商品总数
    // isNoUsefulCard(){
    //   if (this.cardInfo && this.cardInfo.usableCardInfo && )

    // },
  },
  watch: {
    interestsInfo: {
      handler(val) {
        this.cards = JSON.parse(JSON.stringify(val));
      },
      deep: true,
    },
  },
  created() {
    // console.log(this.cardInfo, 2222);
  },
  methods: {
    // 获取商品价格处理
    getPriceDeal(num) {
      if (num) {
        return Number((num * window.union_scale) / 100).toFixed(2);
      }
      return 0;
    },
    bigCardClick(card, good) {
      // console.log("dinajile");
      // 取消
      if (card.checked === "Y") {
        card.checked = "N";
        card.checkedValue = 0;
      } else if (card.checked === "N") {
        const maxNum = good.num - good.totalNum;
        if (maxNum > 0) {
          card.checked = "Y";
          card.checkedValue = maxNum;
        } else {
          Toast.info(payTotastNames.rechooseTimeCard, 1.5);
          return;
        }
      }
      this.handlePaymentParam(good, card);
    },
    clickTimeCard(e, card, type, good) {
      e.stopPropagation();
      if (type === "+") {
        // 是否互斥 Y互斥  不互斥
        if (
          this.interestsInfo &&
          this.interestsInfo.cardInfo &&
          this.interestsInfo.cardInfo.dfCardExclusion === "Y"
        ) {
          // 次卡抵扣不为零
          if (
            this.interestsInfo.cardInfo.usableCardInfo &&
            this.interestsInfo.cardInfo.usableCardInfo.totalPointMoney
          ) {
            Toast.info(payTotastNames.timeOrPointCard, 1.5);
            return;
          }
        }
      }
      // 当前商品可用次卡最大次数(商品数量 - 商品下已抵扣的次卡次数)
      //good.totalNum 当前商品下次卡总抵扣次数
      const maxNum = good.num - good.totalNum;
      if (
        type === "+" &&
        (card.checkedValue > Math.min(good.num, card.balance) ||
          card.showBalance === 0)
      ) {
        return;
      }
      if (type === "-" && card.checkedValue > 0) {
        card.checkedValue = Number(card.checkedValue) - 1;
      }
      if (type === "+") {
        // 当前次卡最大能抵扣的次数
        const max = Math.min(good.num, card.balance);
        if (maxNum > 0) {
          card.checkedValue = Number(card.checkedValue) + 1;
        } else {
          Toast.info(payTotastNames.rechooseTimeCard, 1.5);
          return;
        }
        card.checkedValue = card.checkedValue > max ? max : card.checkedValue;
      }
      if (type === "input") {
        //当前商品下选中的卡
        const selectCard =
          good.timeCards.filter((item) => item.checked === "Y") || [];
        // 当前商品下除当前点击卡以外的选中卡
        const otherCard =
          selectCard.filter((item) => item.cardNo != card.cardNo) || [];
        // 当前商品下除当前点击卡以外的选中卡的抵扣次数
        const otherCardNum = otherCard.reduce(
          (total, item) => total + item.checkedValue,
          0
        );
        const max = Math.min(good.num - otherCardNum, card.balance);
        if (card.checkedValue > max) {
          this.$message.error(
            this.TLang("已为您输入最大可用次数", "orderConfirm")
          );
        }
        card.checkedValue = card.checkedValue > max ? max : card.checkedValue;
      }

      card.checkedValue = card.checkedValue < 0 ? 0 : card.checkedValue;
      if (card.checkedValue > 0) {
        card.checked = "Y";
      } else {
        card.checked = "N";
      }
      this.handlePaymentParam(good, card);
    },

    // 选中后的接口处理
    handlePaymentParam(good, card) {
      var allCard = this.$parent.$parent.allSelectCard;
      allCard.chooseType = 2;
      // 选中
      if (card.checked === "Y") {
        this.sendGio("福利卡", "选择福利卡", {
          status: "勾选",
          contentTitle: card.kindName,
        });
        var obj = {
          categoryId: good.categoryId,
          goodsId: good.goodsId,
          num: good.num,
        };
        let count = allCard.goodsCards.findIndex(
          (per) =>
            per.goodsId === good.goodsId &&
            per.num === good.num &&
            per.categoryId === good.categoryId
        );
        // 已存在这个商品
        if (count > -1) {
          // 商品里是否有这张卡
          let curObj = allCard.goodsCards[count];
          let index = curObj.cardInfos.findIndex(
            (item) => item.cardNo === card.cardNo
          );
          obj.cardInfos = curObj.cardInfos;
          let newCard = {
            cardNo: card.cardNo,
            value: card.checkedValue,
          };
          // 商品里有这张卡，替换
          if (index > -1) {
            obj.cardInfos.splice(index, 1, newCard);
          } else {
            // 没有，添加
            obj.cardInfos.push(newCard);
          }
          allCard.goodsCards.splice(count, 1, obj);
        } else {
          // 不存在这个商品
          obj.cardInfos = [{ cardNo: card.cardNo, value: card.checkedValue }];
          allCard.goodsCards.push(obj);
        }

        // 取消选中状态
      } else {
        this.sendGio("福利卡", "选择福利卡", {
          status: "取消勾选",
          contentTitle: card.kindName,
        });
        const index = allCard.goodsCards.findIndex(
          (per) =>
            per.goodsId === good.goodsId &&
            per.num === good.num &&
            per.categoryId === good.categoryId
        );
        // 找到商品
        if (index > -1) {
          const cardIndex = allCard.goodsCards[index].cardInfos.findIndex(
            (item) => item.cardNo === card.cardNo
          );
          // 找到卡
          if (cardIndex > -1) {
            allCard.goodsCards[index].cardInfos.splice(cardIndex, 1);
            // 没有卡了，删除商品
            if (!allCard.goodsCards[index].cardInfos.length) {
              allCard.goodsCards.splice(index, 1);
            }
          }
        }
      }
      this.$parent.$parent.getChooseData(allCard);
    },
    formatTime(str) {
      if (!str) {
        return "";
      }
      return str.replace(/\-/g, ".");
    },
  },
};
</script>

<style lang="less" scoped>
.timeCardsWrap {
  .timeCardTitle {
    padding: 12px 23px;
    background: #f7f7f7;
  }
  .timeCardProduct {
    padding: 16px 23px;
    display: flex;
  }
  .timeCardContent + .timeCardContent .timeCardProduct {
    border-top: 1px solid #e5e5e5;
  }
  .timeCardProductImg {
    width: 90px;
    height: 90px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
  }
  .timeCardProductInfo {
    margin-top: 10px;
    padding-left: 12px;
    flex: 1;
    line-height: 1;
  }
  .timeCardPropductNum {
    margin-top: 35px;
    font-size: 14px;
  
    color: #999999;
  }
  .timeCardPropductName {
    font-size: 14px;
  
    color: #111111;
  }
  .timeCardPproductPrice {
    min-width: 100px;
    font-size: 14px;
  
    color: #111111;
    text-align: right;
  }
  .timeCards {
    padding-left: 24px;
    display: flex;
    flex-wrap: wrap;
  }
  .timeCard {
    width: 270px;
    margin-right: 24px;
    // margin-bottom: 24px;
  }
  .timeCardInfo {
    position: relative;
    padding: 12px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    background: #f8fcff;
  }
  .timeCard:nth-child(4n) {
    margin-right: 0;
  }
  .cardName {
    max-height: 48px;
    font-size: 16px;
  
    color: #111111;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .cardTxt {
    padding-top: 12px;
    font-size: 12px;
  
    font-weight: 400;
    color: #3d96e2;
  }
  .cardBalance {
    font-size: 24px;
  
    font-weight: 500;
    color: #3d96e2;
    em {
      font-size: 12px;
    }
  }
  .cardNo {
    margin: 12px 0;
    font-size: 12px;
  
    color: #666666;
  }
  .cardRange {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  
    color: #666666;
  }
  .cardTime {
    text-align: left;
  }
  .red-font {
    color: #f44545;
  }
  .cardTips {
    text-align: right;
    img {
      margin-right: -2px;
      width: 12px;
      height: 12px;
      vertical-align: middle;
      margin-top: -1.8px;
    }
    .tipTxt {
      color: #999;
      cursor: pointer;
    }
  }
  .cardNum {
    display: flex;
    height: 24px;
    justify-content: space-between;
    line-height: 24px;
    text-align: center;
    box-sizing: border-box;
  }
  .cardNumTwo {
    display: flex;
    height: 24px;
    justify-content: space-between;
    line-height: 24px;
    text-align: center;
    box-sizing: border-box;
    margin-bottom: 24px;
  }
  .cardReduce {
    width: 40px;
    background: #ffffff;
    border-radius: 0px 0px 0px 2px;
    border-bottom: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    cursor: pointer;
    box-sizing: border-box;
  }
  .cardAdd {
    width: 40px;
    background: #ffffff;
    border-radius: 0px 0px 2px 0px;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    border-right: 1px solid #e5e5e5;
    box-sizing: border-box;
  }
  .gray {
    background: #f7f7f7;
    color: #ccc;
    cursor: not-allowed;
  }
  .unuseable {
    background: #f7f7f7 !important;
    color: #ccc;
  }
  .cardInput {
    flex: 1;
    height: 24px;
    border: none;
    outline: none;
    text-align: center;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    border-top: none;
  }
  .selectedImg {
    display: none;
  }
  .timeCard.selected .timeCardInfo {
    border: 2px solid #3d96e2;
  }
  .timeCard.selected .selectedImg {
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.unUsedCards {
  padding-left: 24px;
  display: flex;
  flex-wrap: wrap;
}
.unUsedCard {
  width: 270px;
  margin-right: 24px;
  margin-bottom: 24px;
}
.unUsedCardInfo {
  padding: 12px;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  background: #f8fcff;
  background: #f6f6f7;
}
.unUsedCard:nth-child(4n) {
  margin-right: 0;
}
.cardName {
  max-height: 48px;
  font-size: 16px;

  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}
.un-cardTxt {
  padding-top: 12px;
  font-size: 12px;

  font-weight: 400;
  color: #333;
}
.un-cardBalance {
  font-size: 24px;

  font-weight: 500;
  color: #333;
  em {
    font-size: 12px;
  }
}
.cardNo {
  margin: 12px 0;
  font-size: 12px;

  color: #666666;
}
.cardRange {
  display: flex;
  justify-content: space-between;
  font-size: 12px;

  color: #666;
}
.cardTime {
  text-align: left;
}
.cardTips {
  text-align: right;
  img {
    margin-right: -2px;
    width: 12px;
    height: 12px;
    vertical-align: middle;
    margin-top: -1.8px;
  }
  .tipTxt {
    color: #999;
    cursor: pointer;
  }
}
.unUsedReason {
  padding: 4px 12px;
  background: #f6f6f7;
  border: 1px solid #e5e5e5;
  border-top: none;
  font-size: 12px;

  font-weight: 400;
  color: #f44545;
  img {
    width: 12px;
    height: 12px;
    padding-right: 5px;
    vertical-align: baseline;
  }
}
.useScope {
  font-size: 14px;

  color: #333333;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.useScope {
  font-size: 14px;

  color: #333333;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.one-time {
  display: flex;
}
.one {
  width: 270px;
  margin-left: 24px;
}
</style>
